// extracted by mini-css-extract-plugin
export default {"input":"kBleeIsmDN06ZDLSiwON"};